import Turnish, { isCodeBlock, NodeTypes, Rules, wrapInlineContent } from '@/index';

export default Object.assign(Turnish, { default: Turnish, isCodeBlock, NodeTypes, Rules, wrapInlineContent });
